import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=d899963c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d899963c')) {
      api.createRecord('d899963c', component.options)
    } else {
      api.reload('d899963c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=d899963c&", function () {
      api.rerender('d899963c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ol8N4oJmbtnX/JS/offershelp.vue"
export default component.exports